import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "echo", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from '@jd/jmtd-tools/es/classnames';
import React from 'react';
import { getValue } from '../tools/util';
import DropdownList from '../DropdownList';
export function getValueFromQuickOption(_ref) {
  var label = _ref.label,
      echo = _ref.echo,
      value = _ref.value,
      other = _objectWithoutProperties(_ref, _excluded);

  return _objectSpread(_objectSpread({}, other), {}, {
    label: label,
    echo: getValue(echo),
    value: getValue(value)
  });
}
var QuickPanel = {
  type: 'quick',
  label: '快捷选择',
  defaultMaxHeight: 330,
  echo: function echo(value) {
    return value && getValueFromQuickOption(value).echo;
  },
  // 回显
  render: function render(_ref2) {
    var value = _ref2.value,
        update = _ref2.update,
        _ref2$config = _ref2.config,
        options = _ref2$config.options,
        _ref2$config$panelWid = _ref2$config.panelWidth,
        panelWidth = _ref2$config$panelWid === void 0 ? 270 : _ref2$config$panelWid;
    value = value && getValueFromQuickOption(value);
    return {
      dropdown: /*#__PURE__*/React.createElement(DropdownList, {
        className: "jmtd-date-picker-panel jmtd-date-picker-quick-panel",
        minHeight: 295,
        width: panelWidth
      }, options.map(function (option) {
        var label = option.label,
            echo = option.echo;
        return /*#__PURE__*/React.createElement("div", {
          key: label,
          className: classNames('jmtd-date-picker-quick-item', {
            'jmtd-date-picker-quick-item-selected': value && label === value.label
          }),
          onClick: function onClick() {
            update(getValueFromQuickOption(option));
          },
          "data-event-content-selector": ".jmtd-date-picker-quick-item-label"
        }, /*#__PURE__*/React.createElement("div", {
          className: "jmtd-date-picker-quick-item-label"
        }, label), /*#__PURE__*/React.createElement("div", {
          className: "jmtd-date-picker-quick-item-echo"
        }, getValue(echo)));
      }))
    };
  }
};
export default QuickPanel;